<template>
  <!--比重题-->
  <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.SpecificGravityQuestion')}}</p>
    <el-row :gutter="10" class="question-box">
      <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
        {{ question.quesIndex + 1 }}
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
        @click="setActiveInput(question.qid)"
      >
        <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				
        <TitleEditor 
          :isTest="true"
            v-if="!isBankViewTest" 
            class="outline-none" 
            :qid="question.qid" 
            :class="question.qid"  
            :value="question.questionsName" 
            :actionTitleEditorShow="activeInputId === question.qid"
            @childValueChange="val=>{ question.questionsName = val }" 
        ></TitleEditor>
      </el-col>
    <el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7 " v-if="!$route.query.index">
      <OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>  
    </el-col>
    </el-row>
    
    <p class="sum">{{$t('main.TotalSpecificGravity')}}：{{question.sum}}</p>
    <draggable class="drag-container" v-model="question.optionList" >
      <transition-group tag="div" type="transition" :name="'flip-list'">
        <el-row
          :gutter="10"
          style="margin-top: 12px !important; margin-bottom: 10px"
          v-for="(childItem, childindex) in question.optionList"
          :key="index + '_' + childindex"
        >
          <div @click="setEditOptionIndex(childindex)">
            <el-row>
              <el-col
                :xs="16"
                :sm="16"
                :md="16"
                :lg="16"
                :xl="16"
                class="el_item_option item_container_title"
                style="margin-left: 50px"
                @click="setActiveInput(childItem.oid)"
              >
              
                <span v-if="isBankViewTest">{{childItem.labelName}}</span>
                <TitleEditor 
                  v-if="!isBankViewTest" 
                  class="outline-none" 
                  :qid="childItem.oid" 
                  :class="childItem.oid"  
                  :value="childItem.labelName" 
                  :actionTitleEditorShow="activeInputId === childItem.oid"
                  @childValueChange="(val) => labelNameChange(val, childItem)" 
                ></TitleEditor>
              </el-col>
              <el-col
                :xs="3"
                :sm="3"
                :md="3"
                :lg="3"
                :xl="3"
                class="el_item_option item_container_title"
              >
                <i
                  class="el-icon-remove el-icon-common-option"
                  v-if="editOptionIndex == childindex"
                  @click="
                    wjdelquestionoption(childItem.oid)
                  "
                ></i>
              </el-col>
            </el-row>
          </div>
          <div class="el-slider-box" @click="setEditOptionIndex(childindex)">
            <el-slider 
                v-model="childItem.userAnswer" 
                :max="0" 
                :show-tooltip="false"
            ></el-slider>
            <span class="num">0</span>
          </div>
        </el-row>
      </transition-group>
    </draggable>
        <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-if="question.isedit && !isBankViewTest"
    >
      <el-col
        :xs="16"
        :sm="16"
        :md="16"
        :lg="16"
        :xl="16"
        class="el_item_option item_container_title"
        style="margin-left: 50px"
      >
        <i
          class="el-icon-plus el-icon-common"
          @click="wjaddquestionoption"
          >{{$t('main.AddOptions')}}</i
        >
        <i
          class="el-icon-s-fold el-icon-common"
          @click="$refs.batchAdd.batchAddshow = true"
          >{{$t('main.BatchAdd')}}</i
        >
      </el-col>
    </el-row>
    
		<BatchAddOption 
			ref="batchAdd"
			:title="$t('main.Proportion')" 
			:functionName="'batchAdd'"
      :question="question"
			@batchAdd="batchAdd"
		/>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
// import DragMixin from "@/components/DragMixin";
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import BatchAddOption from "@/components/myComponents/batchAddOption/batchAddOption.vue"
import OperateWrap from "./collectToBank/operateaWrap.vue"
export default {
	components: {
    	TitleEditor,
      BatchAddOption,
      OperateWrap
	},
  data() {
    return {};
  },
  props: {
    question: {},
    editIndex: { type: Number, default: 0 },
    index: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
  },
  data() {
    return {
      value: '',
      input: 0,
      editOptionIndex: '',
    }
  },
  computed: {
      ...mapState(['activeInputId']),
  },
	mounted(){
		const unwatch = this.$watch('question.optionList', {
      handler(newValue) {
        this.question.optionList = this.question.optionList.map((info) =>{
          this.$set(info, 'isDefault', false)
          return info
        })
        unwatch()
      },
      deep: true
    });
	},
  methods: {
    ...mapActions(['setActiveInput']),
    labelNameChange(val, option) {
      option.labelName = val
    },
    updateQuestion() {
      this.$emit("wjupdquestionoption", this.question);
    },
    batchAdd(optionArr) {
      this.$emit("wjaddquestionoption", this.question.qid, optionArr, this.question.questionsTypeId);
    },
    wjaddquestionoption() {
      this.$emit("wjaddquestionoption", this.question.qid, [this.$t('main.PleaseSelectAProvince')], this.question.questionsTypeId);
    },
    wjdelquestionoption(oid) {
      this.$emit("wjdelquestionoption", { qid: this.question.qid, oid });
    },
    showAdvance(e) {
      this.$emit("showAdvance", e);
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
        this.editOptionIndex = childIndex
        console.log(this.editOptionIndex)
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 10px;
  font-size: 22px !important;
  line-height: 35px !important;
  color: cornflowerblue;
  cursor: pointer;
}



/deep/.el-textarea .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
.outline-none{
  /* display: inline-block; */
  outline: none;
  // max-width: 73%;
}
/deep/.el-input.is-disabled .el-input__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
.sum{
    margin: 10px 0 0 44px;
    color: #606266;
}
.el-slider-box{
    margin-left: 50px;
    display: flex;
    align-items: center;
    .el-slider{
        width: 400px;
    }
    .num{
        margin-left: 10px;
    }
}
</style>
